// extracted by mini-css-extract-plugin
module.exports = {"desktop_only":"(min-width: 1024px)","mobile":"screen and (max-width: 600px)","chip":"chip-WFf8j","close":"close-3ESyu"};